import React from 'react';

import { useDispatch } from 'react-redux';

import Text from '@amzn/meridian/text';
import AppliedFilterTags from 'src/components/shared/appliedFilterTags/appliedFilterTags';
import { removeTagAndUpdateFilter } from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import { useAppSelector } from 'src/store/store';

import './restrictionFormConfiguration.scss';

import RestrictionFormConfigFilterSheet from './restrictionFormConfigSheet/restrictionFormConfigSheet';
import RegionTaskPagination from './restrictionFormPagination/restrictionFormPagination';
import RegionTaskTable from './restrictionFormTable/restrictionFormTable';
import TopOptions from './topOptions/topOptions';

const ViewAndEditForms = () => {
  const dispatch = useDispatch();
  const { restrictionFormTableFilterTags } = useAppSelector((state) => state.regionTasksConfigPage);
  return (
    <div className="view-and-edit-forms">
      <Text className="view-and-edit-forms__content__text">
        Here you can update the regional work Restriction/Requirement forms available within the RTW tool
      </Text>
      <AppliedFilterTags
        filterTags={restrictionFormTableFilterTags}
        onDismissTag={(tag) => dispatch(removeTagAndUpdateFilter(tag))}
        tag-data-testid="restriction-form-table__applied-filter-tag"
      />
      <TopOptions />
      <RegionTaskTable />
      <RegionTaskPagination />
      <RestrictionFormConfigFilterSheet />
    </div>
  );
};

export default ViewAndEditForms;
